import React from 'react';
import { Label } from '../Label/Label';

interface DatePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    id: string;
    label?: string;
    'data-testid'?: string;
}

// Date input styled to match FormInput. Only the native calendar-picker button gets a pointer
// cursor on hover; the field itself keeps the default text cursor.
export const DatePicker: React.FC<DatePickerProps> = ({ id, label, className = '', 'data-testid': dataTestId, ...props }) => {
    const input = (
        <input
            id={id}
            type="date"
            data-testid={dataTestId}
            className={`h-9 px-m rounded-md border border-line bg-primary-50 text-primary-1225 text-compact focus:outline-none focus:border-focus focus:ring-4 focus:ring-focus-ring transition-colors [&::-webkit-calendar-picker-indicator]:cursor-pointer disabled:bg-primary-200 disabled:text-content-secondary disabled:border-line disabled:cursor-not-allowed field-text-mobile ${className}`}
            {...props}
        />
    );

    if (!label) return input;

    return (
        <div className="flex flex-col gap-s">
            <Label htmlFor={id}>{label}</Label>
            {input}
        </div>
    );
};
